// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_d57b439b"};